import { render, staticRenderFns } from "./productBox.vue?vue&type=template&id=1ff029ad&scoped=true"
import script from "./productBox.vue?vue&type=script&lang=js"
export * from "./productBox.vue?vue&type=script&lang=js"
import style0 from "./productBox.vue?vue&type=style&index=0&id=1ff029ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff029ad",
  null
  
)

export default component.exports